import React from 'react';
import { Checkbox } from '@/components/UI/Checkbox/Checkbox';

type Props = {
  dataTestId?: string;
  id?: string;
  label: string;
  isSelected: boolean;
  onSelect: () => void;
};

export function BottomSheetSelectOption({
  dataTestId,
  id,
  label,
  isSelected,
  onSelect,
}: Props) {
  return (
    <Checkbox
      key={label}
      dataTestId={dataTestId}
      id={id}
      label={label}
      value={isSelected}
      appearance="radio"
      size="lg"
      onChangeHook={onSelect}
    />
  );
}
